import { motion } from 'framer-motion';
import styled from 'styled-components';

export const TriggerButtonWrapper = styled.div`
    position: absolute;
    top: 20%;
    right: 10%;
    z-index: 1;
    pointer-events: all;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        top: 25px;
        right: 25px;
    }
`;

export const ExpandButton = styled(motion.button)`
    background: ${({ theme }) => theme.shades.white['10']};
    border: none;
    backdrop-filter: blur(24px);
    border-radius: 67.562px;
    width: 40px;
    height: 40px;
    z-index: 10;
    display: flex;
    place-content: center;
    place-items: center;

    cursor: pointer;

    svg {
        width: 16px;
        height: 16px;
    }
`;
